import { Pipe, PipeTransform, Injectable } from "@angular/core";

@Pipe({
  name: 'imageConverter',
  standalone: true
})
@Injectable({ providedIn: 'root' })
export class ImageConverterPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    const extRegex = /\.(png|jpg|jpeg)$/i;
    const folderRegex = /^assets\/img/i;

    if (extRegex.test(value)) {
      const webpPath = value.replace(extRegex, '.webp');
      return webpPath.replace(folderRegex, 'assets/webp');
    }
    return value;
  }
}
